import { useDispatch, useSelector } from "react-redux";
import { sortAction, searchAction } from "../../features/filter/filterSlice";

export default function Search() {
  const { search, sort } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  return (
    <div className="flex gap-4">
      <div className="search-field group flex-1">
        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
        <input
          type="text"
          placeholder="Search Job"
          className="search-input"
          id="lws-searchJob"
          value={search}
          onChange={(e) => dispatch(searchAction(e.target.value))}
        />
      </div>
      <select
        id="lws-sort"
        name="sort"
        autoComplete="sort"
        className="flex-1"
        value={sort}
        onChange={(e) => dispatch(sortAction(e.target.value))}
      >
        <option value="default">Default</option>
        <option value="asc">Salary (Low to High)</option>
        <option value="desc">Salary (High to Low)</option>
      </select>
    </div>
  );
}
